import React, { useEffect, useState } from "react";
import OwnerAssignment from "../OwnerAssignment";
import FormEditAndAddControl from "../../../components/BuilderComponents/FormEditAndAddControl";
import { useParams } from "react-router-dom";
import { useAxiosContext } from "../../../context/AxiosContext";
import FieldTag from "../../Form/FieldTags/FieldTag";
import { getFieldIcon } from "../../../utils/getFieldIcon";
import Input from "../../../components/FormComponents/Input";
import Textarea from "../../../components/FormComponents/Textarea";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Button from "../../../components/FormComponents/Button";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import OwnerAssignmentCard from "../OwnerAssignmentCard";

export const EditActityOption = ({ statesObject, selectedItemData, setSelectedItemData, gatewayObject }) => {
  const [selectedActivityTab, setSelectedActivityTab] = useState("summary");
  const [allGroups, setAllGroups] = useState([]);
  const { orgId } = useParams();
  const { axiosInstance } = useAxiosContext();
  const { smId } = useParams();

  const fetchAllGroups = async () => {
    try {
      const response = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
      setAllGroups(response.data); // Update the state with the fetched groups
    } catch (error) {
      console.error("Error fetching all groups:", error);
    }
  };

  useEffect(() => {
    fetchAllGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let statesKeyArray = Object.keys(statesObject);

  const addStateChangeLogic = () => {
    let rememberObj = { ...selectedItemData };
    if (rememberObj.state_change_logic) {
      rememberObj.state_change_logic.push({ state_id: "", condition: "true" });
    } else {
      rememberObj.state_change_logic = [{ state_id: "", condition: "true" }];
    }
    setSelectedItemData(rememberObj);
  };

  const addGatewayChangeLogic = () => {
    let rememberObj = { ...selectedItemData };
    if (rememberObj.gateway_change_logic) {
      rememberObj.gateway_change_logic.push({ gateway_id: "", condition: "true" });
    } else {
      rememberObj.gateway_change_logic = [{ gateway_id: "", condition: "true" }];
    }
    setSelectedItemData(rememberObj);
  };

  const changeLogic = (key, value, index) => {
    let rememberObj = { ...selectedItemData };
    rememberObj.state_change_logic[index][key] = value;
    setSelectedItemData(rememberObj);
  };

  const changeGatewayLogic = (key, value, index) => {
    let rememberObj = { ...selectedItemData };
    rememberObj.gateway_change_logic[index][key] = value;
    setSelectedItemData(rememberObj);
  };

  const settingOwnerAssignment = (data) => {
    setSelectedItemData({ ...selectedItemData, activity_owner_assignment: data });
  };

  const deleteStateChangeLogic = (index) => {
    let rememberObj = { ...selectedItemData };
    rememberObj.state_change_logic.splice(index, 1);
    setSelectedItemData(rememberObj);
  };
  const deleteGatewayChangeLogic = (index) => {
    let rememberObj = { ...selectedItemData };
    rememberObj.gateway_change_logic.splice(index, 1);
    setSelectedItemData(rememberObj);
  };

  return (
    <>
      <div className="sidebar_tab_buttons mediumtab">
        {["summary", "state change logic", "gateway change logic", "owner assignment"].map((name) => (
          <div
            className={`sidebar_tabs ${selectedActivityTab === name && "active"}`}
            onClick={() => setSelectedActivityTab(name)}
            key={name}
          >
            {name}
          </div>
        ))}
      </div>
      <div
        className="sm_blueprint_editBox_inside"
        style={{ padding: selectedActivityTab === "owner assignment" ? "0px" : "20px 20px 50px 20px" }}
      >
        {selectedActivityTab === "summary" && (
          <div>
            <div className="builder_form mb_3">
              <Input
                label="Activity Name"
                value={selectedItemData.name}
                onChange={(e) => setSelectedItemData({ ...selectedItemData, name: e.target.value })}
              />
            </div>
            <div>
              <span className="section_main_heading">State Change Logic</span>
            </div>
            <div className="summary_card">
              <div className="form_edit_del_buttons">
                <button
                  className="builder_action_btn  edit"
                  title=""
                  style={{ width: "32px", height: "32px", fontsize: "20px" }}
                  onClick={() => setSelectedActivityTab("state change logic")}
                >
                  <MaterialIcon name="edit" style={{ fontSize: "20px" }} />
                </button>
              </div>
              <div className="overlay_cover"></div>
              <div className="state_changeLogic_summary_container">
                {selectedItemData?.state_change_logic?.length > 0 ? (
                  selectedItemData.state_change_logic.map((logic, index) => (
                    <div key={index} className="stateMachine_form_container_item">
                      <div className="builder_label">
                        State Name:{" "}
                        <span className="key_tag">{logic.state_id ? statesObject[logic.state_id]?.name : "None"}</span>
                      </div>
                      <div className="builder_label">
                        Condition: <span className="key_tag">{logic.condition}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="key_tag">
                    <p>None</p>
                  </div>
                )}
              </div>
            </div>
            <div>
              <span className="section_main_heading">Activity Ownership</span>
            </div>
            <div className="summary_card">
              <div className="form_edit_del_buttons">
                <button
                  className="builder_action_btn  edit"
                  title=""
                  style={{ width: "32px", height: "32px", fontsize: "20px" }}
                  onClick={() => setSelectedActivityTab("owner assignment")}
                >
                  <MaterialIcon name="edit" style={{ fontSize: "20px" }} />
                </button>
              </div>
              <div className="overlay_cover"></div>
              <div className="owner_assignment_summary_container">
                <OwnerAssignmentCard
                  ownerAssignment={selectedItemData.activity_owner_assignment}
                  setOwnerAssignment={settingOwnerAssignment}
                  allGroups={allGroups}
                />
              </div>
            </div>
            <span className="section_main_heading">Form</span>
            <div className="summary_card">
              <RenderForm selectedItemData={selectedItemData} tableId={smId} />
            </div>
          </div>
        )}
        {selectedActivityTab === "state change logic" && (
          <div>
            <div className="inline_tag_items">
              <div className="section_main_heading">State Change Logic</div>
              <MaterialIcon name="add" className="builder_action_btn" onClick={addStateChangeLogic} />
            </div>
            <div className="state_changeLogic_inputs_container">
              {selectedItemData?.state_change_logic?.map((logic, index) => (
                <StateChangeLogicItem
                  key={index}
                  index={index}
                  logic={logic}
                  changeLogic={changeLogic}
                  statesKeyArray={statesKeyArray}
                  statesObject={statesObject}
                  deleteStateChangeLogic={deleteStateChangeLogic}
                />
              ))}
            </div>
          </div>
        )}
        {selectedActivityTab === "gateway change logic" && (
          <div>
            <div className="inline_tag_items">
              <div className="section_main_heading">Gateway Change Logic</div>
              <MaterialIcon name="add" className="builder_action_btn" onClick={addGatewayChangeLogic} />
            </div>
            <div className="state_changeLogic_inputs_container">
              {selectedItemData?.gateway_change_logic?.map((logic, index) => (
                <GatewayChangeLogic
                  key={index}
                  index={index}
                  logic={logic}
                  changeLogic={changeGatewayLogic}
                  gatewayObject={gatewayObject} // Pass your gateway object here instead of statesObject
                  deleteGatewayChangeLogic={deleteGatewayChangeLogic}
                />
              ))}
            </div>
          </div>
        )}
        {selectedActivityTab === "owner assignment" && (
          <OwnerAssignment
            ownerAssignment={selectedItemData.activity_owner_assignment}
            setOwnerAssignment={settingOwnerAssignment}
          />
        )}
      </div>
    </>
  );
};

const StateChangeLogicItem = ({ index, logic, changeLogic, statesObject, deleteStateChangeLogic }) => {
  const [addLogicFlag, setAddLogicFlag] = useState();

  useEffect(() => {
    setAddLogicFlag(logic?.condition.includes("true") ? true : false);
    // if (!logic) {
    //   setIsOpen(false);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logic]);
  return (
    <div className="summary_card" key={index}>
      <div className="builder_form g_4">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <label className="builder_label"> Select state</label>
          <MaterialIcon
            name="delete"
            className="builder_action_btn"
            style={{ marginLeft: "auto" }}
            onClick={() => deleteStateChangeLogic(index)}
          />
        </div>
        <SingleSelectBox
          selectedData={logic.state_id}
          options={Object.values(statesObject)}
          onChange={(obj) => changeLogic("state_id", obj.id, index)}
          placeholder="Select State"
        />
      </div>
      {logic?.state_id && addLogicFlag && (
        <>
          <label className="builder_label" style={{ marginTop: "10px" }}>
            {" "}
            Logic
          </label>
          <div className="builder_displayBox" style={{ marginTop: "10px" }}>
            Without logic it goes to
            <span className="highlighted_text_color"> {statesObject[logic?.state_id]?.name} </span>
          </div>
          <Button
            variant="secondary mt_3"
            onClick={() => {
              setAddLogicFlag(false);
              changeLogic("condition", "", index);
            }}
          >
            Add Logic
          </Button>
        </>
      )}
      {!addLogicFlag && (
        <Button
          variant="secondary mt_3 mb_2"
          onClick={() => {
            setAddLogicFlag(true);
            changeLogic("condition", "true", index);
          }}
        >
          Remove Logic
        </Button>
      )}
      {!addLogicFlag && (
        <div className="builder_form">
          <Textarea
            label="Condition"
            //
            value={logic.condition}
            onChange={(e) => changeLogic("condition", e.target.value, index)}
          />
        </div>
      )}
    </div>
  );
};

const GatewayChangeLogic = ({ index, logic, changeLogic, gatewayObject, deleteGatewayChangeLogic }) => {
  return (
    <div className="summary_card" key={index}>
      <div className="builder_form g_4">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <label className="builder_label">Select gateway</label>
          <MaterialIcon
            name="delete"
            className="builder_action_btn"
            style={{ marginLeft: "auto" }}
            onClick={() => deleteGatewayChangeLogic(index)}
          />
        </div>
        <SingleSelectBox
          selectedData={logic.gateway_id}
          options={Object.values(gatewayObject)}
          onChange={(obj) => changeLogic("gateway_id", obj.id, index)}
          placeholder="Select Gateway"
        />
      </div>
      <div className="builder_form">
        <Textarea
          label="Condition"
          value={logic.condition}
          onChange={(e) => changeLogic("condition", e.target.value, index)}
        />
      </div>
    </div>
  );
};

const RenderForm = ({ selectedItemData, tableId }) => {
  const [isMultipleFormSections, setIsMultipleFormSections] = useState(false);
  const [sections, setSections] = useState([]); // State to store sections
  const [formIsThere, setFormISThere] = useState(false);
  const [sectionIndex, setSectionIndex] = useState(0);

  useEffect(() => {
    if (selectedItemData.form?.sections) {
      setSections(selectedItemData.form.sections);
    } else {
      setSections([]);
    }
    setIsMultipleFormSections(selectedItemData?.form?.settings?.isMultiple || false);
    const bool = selectedItemData.form?.id ? { name: selectedItemData.form.name } : false;
    setFormISThere(bool);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemData.id]);

  return (
    <div className="form_field_container" style={{ marginTop: "40px" }}>
      <div style={{ position: "relative" }} className="activity_select_top">
        <div className="ent_form_fields">
          <FormEditAndAddControl formIsThere={formIsThere} smId={tableId} activityId={selectedItemData.id} />
        </div>
        {sections.length > 0 && formIsThere && (
          <div className="form_field_outer" style={{ marginTop: "-50px" }}>
            <div className="overlay_cover"></div>
            <div>
              {isMultipleFormSections && (
                <div className="form_add_section_inside">
                  {sections.map((section, index) => (
                    <div
                      key={index}
                      className={`section-button ${index === sectionIndex ? "active" : ""}`}
                      onClick={() => setSectionIndex(index)}
                    >
                      {section.name.charAt(0).toUpperCase() + section.name.slice(1)}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div>
              {sections.length > 0 && sectionIndex !== undefined && (
                <div className="stateMachine_form_container">
                  {sections[sectionIndex].fields?.map((field) => {
                    const { ...fieldWithoutKey } = field;
                    return (
                      <div key={field.id} className={`single_field_render`}>
                        <MaterialIcon
                          name={getFieldIcon(field.type)}
                          style={{ color: "#667085", marginRight: "8px" }}
                        />
                        <div className="form_element_container">
                          <FieldTag key={field.id} element={fieldWithoutKey} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export { RenderForm, GatewayChangeLogic };
